<template xmlns="http://www.w3.org/1999/html">
  <Head title="Daftar Pengguna Baru" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form @submit.prevent="store">
        <div class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
          <div class="px-10 py-12">
            <h1 class="text-center text-3xl font-bold">Daftar Pengguna</h1>
            <div class="mt-6 mb-4 mx-auto w-24 border-b-2 items-center text-center" />
            <div class="max-w-3xl overflow-hidden">
              <div class="flex flex-wrap">
                <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-4 w-full" label="Nama Pertama" />
                <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-4 w-full" label="Nama Akhir" />
                <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-4 w-full" label="Emel" />
                <text-input v-model="form.username" :error="form.errors.username" class="pb-8 pr-6 w-full" label="Nama Pengguna" />
                <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-4 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Kata Laluan" />
                <text-input v-model="form.password_confirmation" :error="form.errors.password_confirmation" class="pb-8 pr-4 w-full lg:w-1/2" label="Sahkan Kata Laluan" type="password" />
              </div>
            </div>
          </div>
          <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
            <div class="mt-auto mb-auto">
              <a class="hover:underline" tabindex="-1" href="/login">Kembali</a>
            </div>
            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Daftar</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    TextInput,
    LoadingButton,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        username: '',
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/register')
    },
  },
}
</script>
